import React, { useState, useEffect } from "react";
import { Container, Typography, Box } from "@mui/material";
import VersionHistoryCard from "../Components/VersionHistoryCard";
import { useLocation, useNavigate } from "react-router-dom";
import logoPlaceHolder from '../assets/logoPlaceholder.jpg';
import { isURL } from '../utils/utility';
import { fetchComponentHistory, getComponentDetails } from "../utils/api";
import ConfirmDialog from "../Components/ConfirmDialog";
import CustomSnackBar from '../Components/CustomSnackBar';
import { useGlobal } from "../Context/globalContext";


const statusColorMap = {
    underReview: { statusColor: "info", borderColor: "skyblue" },
    submitted: { statusColor: "warning", borderColor: "goldenrod" },
    publish: { statusColor: "warning", borderColor: "goldenrod" },
    tested: { statusColor: "success", borderColor: "green" },
    unpublish: { statusColor: "error", borderColor: "red" },
    "all-unpublish": { statusColor: "error", borderColor: "red" },
    approved: { statusColor: "success", borderColor: "green" },
    rejected: { statusColor: "error", borderColor: "red" },
};


const VersionHistoryPage = () => {
    const { userData } = useGlobal();
    const location = useLocation();
    const { downloadUrl, item, componentName: stateComponentName } = location.state || {};
    const logoName = item?.info?.logo;
    const imageUrl = logoName && isURL(logoName) ? logoName : downloadUrl && logoName ? `${downloadUrl}/${logoName}` : '';
    const [imgSrc, setImgSrc] = useState(imageUrl || logoPlaceHolder);
    const [versions, setVersions] = useState(null)
    const [error, setError] = useState('');
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentDialog, setCurrentDialog] = useState(null);
    const [componentScope, setComponentScope] = useState('');
    const [commentMessage, setCommentMessage] = useState('');
    const [selectedVersionToAct, setSelectedVersionToAct] = useState(null);
    const [packageInfo, setPackageInfo] = useState({});
    // const navigate = useNavigate()

    // Parse query params
    const searchParams = new URLSearchParams(location.search);
    const queryComponentName = searchParams.get('componentName');

    // Final componentName with fallback
    const componentName = stateComponentName || queryComponentName;

    const fetchPackageInfo = async () => {
        try {
            const result = await getComponentDetails(componentName);
            if (result?.data) {
                setPackageInfo(result.data);
                getComponentHistory(result.data)
            }
        } catch (error) {
            console.error("Error fetching packageData:", error);
        }
    };



    const openDialog = (dialogType, comment, version) => {
        setCommentMessage(comment)
        setCurrentDialog(dialogType);
        setSelectedVersionToAct(version);
        setDialogOpen(true);
    };


    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSnackBar(false);
    };


    const movePackageHandler = async (type, checkBoxes = null) => {
        setShowLoader(true);
        // const version = item?.info?.underReview;
        const version = selectedVersionToAct || packageInfo?.review?.component_version;


        let url = "";
        let requestOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                comment: commentMessage
            })
        };

        if (type === "dev") {
            url = `/nodeapi/portal/move-to-dev?componentName=${componentName}&version=${version}`;
        }
        else if (type === "staging") {
            url = `/nodeapi/portal/move-resource-to-staging?componentName=${componentName}&version=${version}`;
        }
        else if (type === "prod") {
            url = `/nodeapi/portal/move-to-prod?componentName=${componentName}&version=${version}`;
        } else if (type === "markTested") {
            url = `/nodeapi/portal/update-review-status?componentName=${componentName}&status=tested&version=${version}`;
        }

        try {
            const response = await fetch(url, requestOptions);
            const result = await response.json();

            if (result && result.success === 1) {
                fetchPackageInfo()
                setShowLoader(false);
                setOpenSnackBar(true);
                setCommentMessage("")
                setSnackbarMessage(
                    type === "prod"
                        ? "Package moved to production Successfully"
                        : type === "dev"
                            ? "Package moved to development successfully"
                            : type === "staging" ? "Resource Moved to Staging Successfully!" :
                                "Component Version successfully marked as Tested"
                );
                setError(false);
            } else {
                setShowLoader(false);
                setOpenSnackBar(true);
                setCommentMessage("")
                setError(
                    type === "prod"
                        ? "Error in moving package to production"
                        : type === "dev"
                            ? "Error in moving package to development"
                            : type === "staging"
                                ? "Error in moving resource to Staging!"
                                : "Error in marking version as Tested"
                );
            }
        } catch (error) {
            console.error("Error:", error);
            setShowLoader(false);
            setOpenSnackBar(true);
            // setError("Error in moving package to development");
            setError(
                type === "prod"
                    ? "Error in moving package to production"
                    : type === "dev"
                        ? "Error in moving package to development"
                        : type === "staging"
                            ? "Error in moving resource to Staging!"
                            : "Error in marking version as Tested"
            );
        }
    };


    const rejectHandler = async (type) => {
        setShowLoader(true);
        const version = selectedVersionToAct || item?.info?.underReview;

        const url = `/nodeapi/portal/reject-package-version?componentName=${componentName}&version=${version}&type=${type}`;

        const requestOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                comment: commentMessage
            }),
        };

        try {
            const response = await fetch(url, requestOptions);
            const result = await response.json();

            if (result && result.success === 1) {
                fetchPackageInfo();
                setShowLoader(false);
                setCommentMessage("")
                setOpenSnackBar(true);
                setSnackbarMessage(
                    type === "prod"
                        ? "Discarded this version on production Successfully"
                        : "Discarded this version on development Successfully"
                );
                setError(false);
                //   navigate("/pending-review", {
                //     state: { selectedCategory: "pending-review" },
                //   });
            } else {
                setShowLoader(false);
                setOpenSnackBar(true);
                setCommentMessage("")
                setError(
                    type === "prod"
                        ? "Error in discarding this version on production"
                        : "Error in discarding this version on development"
                );
            }
        } catch (error) {
            console.error("Error:", error);
            setShowLoader(false);
            setOpenSnackBar(true);
            setError("Error in moving package to development");
        }
    };


    const handleConfirm = () => {
        switch (currentDialog) {
            case 'moveToDev':
                movePackageHandler('dev');
                break;
            case 'moveToProd':
                movePackageHandler('prod');
                break;
            case 'rejectDev':
                rejectHandler('dev');
                break;
            case 'rejectProd':
                rejectHandler('prod');
                break;
            case 'moveResourceToStaging':
                movePackageHandler('staging');
                break;
            case 'markTested':
                movePackageHandler('markTested');
                break;
            default:
                console.warn('Unhandled dialog type:', currentDialog);
        }
        setDialogOpen(false);
    };


    useEffect(() => {
        if (componentName) {
            const packageNameScope = componentName.split('/')[0]
            const scope = packageNameScope.substring(1).split('@')[0];
            setComponentScope(scope);
            fetchPackageInfo()
        }

    }, [componentName]);

    const getComponentHistory = () => {
        const actionableStatuses = ['submitted', 'underReview', 'tested', 'resourceToStaging'];
        const reviewStatuses = ['underReview', 'tested'];

        fetchComponentHistory(componentName)
            .then((data) => {
                if (data.history) {
                    const currentVersionOnProd = data.currentVersionOnProd;
                    
                    const compareVersions = (v1, v2) => {
                        const p1 = (v1 || '0').split('.').map(Number);
                        const p2 = (v2 || '0').split('.').map(Number);
                        for (let i = 0; i < Math.max(p1.length, p2.length); i++) {
                            const n1 = p1[i] || 0;
                            const n2 = p2[i] || 0;
                            if (n1 !== n2) {
                                return n1 - n2;
                            }
                        }
                        return 0;
                    };

                    let testedVersions = new Set();
                    if (data.history && data.history.length) {
                        data.history.forEach(item => {
                            if (item.component_status === 'tested') {
                                testedVersions.add(item.component_version);
                            }
                        });
                    }

                    // const updatedData = data.history.length ? underReview.concat(data.history) : underReview;
                    const mappedVersions = data.history.length ? data.history.map((item, i) => {
                        const { statusColor, borderColor } =
                            statusColorMap[item.component_status] ||
                            statusColorMap["underReview"];

                        let showActions =
                            (i === 0 && actionableStatuses.includes(item.component_status)) ||
                            (reviewStatuses.includes(item.component_status) &&
                                compareVersions(item.component_version, currentVersionOnProd) > 0);
                        // if some version is already tested then we should not show actions for that version to mark it as tested again

                        if (item.component_status === 'underReview' && testedVersions.has(item.component_version)) {
                            showActions = false;
                        }

                        return {
                            version: item.component_version || "-",
                            date: item.action_date
                                ? new Date(item.action_date).toLocaleString()
                                : "-",
                            status: item.component_status,
                            statusColor,
                            comment: item.comment || "",
                            showActions: showActions,
                            borderColor,
                            submittedBy: item.userID,
                        };
                    }) : []

                    setVersions(mappedVersions);
                }
            })
            .catch((err) => {
                console.error("Error fetching component history:", err);
            });
    };


    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <ConfirmDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={handleConfirm}
                showIntegratedCheckBoxes={currentDialog === 'moveIntegratedToProd'}
                title={currentDialog === 'moveToDev'
                    ? 'Are you sure you want to move this package to development?'
                    : currentDialog === 'moveToProd'
                        ? 'Are you sure you want to move this package to production?'
                        : currentDialog === "rejectDev"
                            ? 'Are you sure you want to discard this version to move to dev for testing?'
                            : currentDialog === "rejectProd"
                                ? 'Are you sure you want to discard this version to move to production?'
                                : currentDialog === "markTested"
                                    ? 'Are you sure you want to mark this version Tested'
                                    : currentDialog === "moveResourceToStaging"
                                        ? 'Are you sure you want to move resource file from dev to staging'
                                        : ''

                }
                confirmText="Confirm"
                cancelText="Cancel"
            />
            <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
                <Box sx={{
                    width: "80px",
                    marginRight: "20px",
                }}>
                    <img
                        src={imgSrc}
                        alt="packageIcon"
                        style={{ width: '100%' }}
                        onError={() => setImgSrc(logoPlaceHolder)}
                    />
                </Box>

                <Box>
                    <Typography variant="h5" fontWeight="bold">
                        {componentName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {/* Approval History */}
                    </Typography>
                </Box>
            </Box>
            {/* Version History Card */}
            <VersionHistoryCard
                versions={versions}
                openDialog={openDialog}
                showLoader={showLoader}
                userData={userData}
                componentName={componentName}
                commentMessage={commentMessage}
                componentScope={componentScope} />

            <CustomSnackBar
                open={openSnackBar}
                handleClose={handleClose}
                error={error}
                message={snackbarMessage}
            />
        </Container>
    );
};

export default VersionHistoryPage;
